import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgWoongebouw = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <mask
      id="Woongebouw_svg__a"
      width={24}
      height={30}
      x={8}
      y={5}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <path
        fill="#fff"
        d="M31.5 6.03v27.94c0 .56-.47 1.03-1.05 1.03H9.55c-.57 0-1.05-.47-1.05-1.03V6.03C8.5 5.47 8.97 5 9.55 5h20.91c.57 0 1.05.47 1.05 1.03zM14.77 9.22c0-.29-.23-.52-.52-.52H13.2c-.29 0-.52.23-.52.52v1.05c0 .29.23.52.52.52h1.05c.29 0 .52-.23.52-.52zm0 4.18c0-.29-.23-.52-.52-.52H13.2c-.29 0-.52.23-.52.52v1.05c0 .29.23.52.52.52h1.05c.29 0 .52-.23.52-.52zm0 4.18c0-.29-.23-.52-.52-.52H13.2c-.29 0-.52.23-.52.52v1.05c0 .29.23.52.52.52h1.05c.29 0 .52-.23.52-.52zm0 4.18c0-.29-.23-.52-.52-.52H13.2c-.29 0-.52.23-.52.52v1.05c0 .29.23.52.52.52h1.05c.29 0 .52-.23.52-.52zm0 4.19c0-.29-.23-.52-.52-.52H13.2c-.29 0-.52.23-.52.52V27c0 .29.23.52.52.52h1.05c.29 0 .52-.23.52-.52zm2.09-15.69c0 .29.23.52.52.52h1.05c.29 0 .52-.23.52-.52V9.21c0-.29-.23-.52-.52-.52h-1.05c-.29 0-.52.23-.52.52zm0 4.19c0 .29.23.52.52.52h1.05c.29 0 .52-.23.52-.52V13.4c0-.29-.23-.52-.52-.52h-1.05c-.29 0-.52.23-.52.52zm0 4.18c0 .29.23.52.52.52h1.05c.29 0 .52-.23.52-.52v-1.05c0-.29-.23-.52-.52-.52h-1.05c-.29 0-.52.23-.52.52zm0 4.18c0 .29.23.52.52.52h1.05c.29 0 .52-.23.52-.52v-1.05c0-.29-.23-.52-.52-.52h-1.05c-.29 0-.52.23-.52.52zm6.28 3.14c0-.29-.23-.52-.52-.52h-5.23c-.29 0-.52.23-.52.52v6.64c0 .29.23.52.52.52h5.23c.29 0 .52-.23.52-.52zm0-16.73c0-.29-.23-.52-.52-.52h-1.05c-.29 0-.52.23-.52.52v1.05c0 .29.23.52.52.52h1.05c.29 0 .52-.23.52-.52zm0 4.18c0-.29-.23-.52-.52-.52h-1.05c-.29 0-.52.23-.52.52v1.05c0 .29.23.52.52.52h1.05c.29 0 .52-.23.52-.52zm0 4.18c0-.29-.23-.52-.52-.52h-1.05c-.29 0-.52.23-.52.52v1.05c0 .29.23.52.52.52h1.05c.29 0 .52-.23.52-.52zm0 4.18c0-.29-.23-.52-.52-.52h-1.05c-.29 0-.52.23-.52.52v1.05c0 .29.23.52.52.52h1.05c.29 0 .52-.23.52-.52zm4.18-12.54c0-.29-.23-.52-.52-.52h-1.05c-.29 0-.52.23-.52.52v1.05c0 .29.23.52.52.52h1.05c.29 0 .52-.23.52-.52zm0 4.18c0-.29-.23-.52-.52-.52h-1.05c-.29 0-.52.23-.52.52v1.05c0 .29.23.52.52.52h1.05c.29 0 .52-.23.52-.52zm0 4.18c0-.29-.23-.52-.52-.52h-1.05c-.29 0-.52.23-.52.52v1.05c0 .29.23.52.52.52h1.05c.29 0 .52-.23.52-.52zm0 4.18c0-.29-.23-.52-.52-.52h-1.05c-.29 0-.52.23-.52.52v1.05c0 .29.23.52.52.52h1.05c.29 0 .52-.23.52-.52zm0 4.19c0-.29-.23-.52-.52-.52h-1.05c-.29 0-.52.23-.52.52V27c0 .29.23.52.52.52h1.05c.29 0 .52-.23.52-.52z"
      />
    </mask>
    <g mask="url(#Woongebouw_svg__a)">
      <path
        fill="#F7A941"
        d="m25.86 49.92-12.25-7.07 7.07-12.25z"
      />
      <path
        fill="#F18700"
        d="m20.68 30.6-7.07 12.25-12.25-7.08z"
      />
      <path
        fill="#F7A941"
        d="m20.68 30.6 12.25 7.07-7.07 12.25z"
      />
      <path
        fill="#F7A941"
        d="m40 25.42-7.07 12.25-12.25-7.07zM15.51 11.28 3.26 4.21l7.07-12.25zM-3.81 16.46 3.26 4.21l12.25 7.07zM34.82 6.1 22.58-.97l7.07-12.24z"
      />
      <path
        fill="#F7A941"
        d="M10.33-8.04 22.58-.97l-7.07 12.25z"
      />
      <path
        fill="#F18700"
        d="M15.51 11.28 22.58-.97 34.82 6.1z"
      />
      <path
        fill="#F7A941"
        d="m15.51 11.28 12.24 7.07-7.07 12.25z"
      />
      <path
        fill="#F18700"
        d="m40 25.42-12.25-7.07L34.82 6.1z"
      />
      <path
        fill="#F7A941"
        d="m34.82 6.1-7.07 12.25-12.24-7.07zM20.68 30.6l7.07-12.25L40 25.42zM20.68 30.6 8.43 23.53l7.08-12.25z"
      />
      <path
        fill="#F7A941"
        d="M15.51 11.28 8.43 23.53l-12.24-7.07z"
      />
      <path
        fill="#F18700"
        d="m1.36 35.77 7.07-12.24 12.25 7.07zM29.65-13.21l12.24 7.07L34.82 6.1z"
      />
    </g>
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgWoongebouw);

export default ForwardRef;
